import React, { useState } from 'react'
import DistributionToMobileUserForm from './DistributionToMobileUserForm';
import DistributionToMobileUserList from './DistributionToMobileUserList';

const DistributionToMobileUser= () => {
    const [fromIsShown, setFromIsShown] = useState(false);
    const [upData, setUpData] = useState(false);
    const [serviceId, setServiceId] = useState("none");

  return (
    <>
      {fromIsShown ? (
          <DistributionToMobileUserForm addForm={setFromIsShown} update={upData} sId={serviceId}/>
        ) : (
          <DistributionToMobileUserList addForm={setFromIsShown} update={setUpData} sId={setServiceId}/>
        )}
  
    </>
  )
}

export default DistributionToMobileUser;